import { UiSchema } from '@rjsf/utils'

import { calculateAreaMeasurementsForMaterial } from '../imup/sagas/2D/createDrawableLocation'
import { FormProperties } from '../imup/types'
import { ActiveDrawable } from '../models/activeDrawable'
import { GeneralDrawableSettings } from '../models/activeDrawableSettings'
import { Region } from '../models/region'
import { DRAWABLE_TYPES } from '../shared/constants/drawable-types'
import { parseScaleFactorLabel } from '../utils/calculations/scaleConversion/scaleConversion'
import { calculateTotalArea } from '../utils/formSchema/formSchema-helper-functions'
import { convertFullNumberFractionToDecimal, truncateToDecimals } from '../utils/formSchema/numberConversion'

const pitchOtherValue = 'other'

const uiSchema: UiSchema = {
    'ui:order': ['type', 'selection', 'pitch', 'pitch_other'],
    selection: {
        'ui:placeholder': 'Select Roofing ',
    },
    type: {
        'ui:placeholder': 'Select Exterior Roofing Type',
    },
    pitch: {
        'ui:placeholder': 'Select Pitch',
    },
}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    if (newSettings.pitch === pitchOtherValue && newSettings.pitch_other) {
        newSettings.pitch =
            convertFullNumberFractionToDecimal(String(newSettings.pitch_other)) ?? newSettings.pitch_other
        newSettings.pitch = truncateToDecimals(newSettings.pitch)

        delete newSettings.pitch_other
    } else if (newSettings.pitch !== pitchOtherValue) {
        newSettings.pitch_other = null
    }

    return newSettings
}

const onValidate = () => {}

/**
 * Augment the drawables of the from based on the new settings
 * @returns
 * @param input
 */
function prepareDrawables(input: {
    drawables: ActiveDrawable[]
    newSettings: GeneralDrawableSettings
    scaleFactor: number
    dpi: number | null
    pdfScale: number
    xCalibrationFactor: number
    yCalibrationFactor: number
    regions: Region[]
    is3D?: boolean
}): ActiveDrawable[] {
    const { drawables, newSettings, scaleFactor, dpi, pdfScale, xCalibrationFactor, yCalibrationFactor, regions } =
        input

    return drawables.map((drawable) => {
        const totalArea: number = calculateTotalArea(
            drawable.opening_locations,
            regions,
            parseScaleFactorLabel(drawable.additional_data.scale_factor) ?? scaleFactor,
            pdfScale,
            xCalibrationFactor,
            yCalibrationFactor,
            dpi
        )

        drawable.settings.quantity = calculateAreaMeasurementsForMaterial(totalArea, {
            type: DRAWABLE_TYPES.EXTERIOR_ROOFING,
            settings: newSettings,
        })

        return drawable
    })
}

const form: FormProperties = { uiSchema, onValidate, onSubmit, prepareDrawables }

export default form
